import { render, staticRenderFns } from "./NewSidebar.vue?vue&type=template&id=fa9c5084"
import script from "./NewSidebar.vue?vue&type=script&lang=js"
export * from "./NewSidebar.vue?vue&type=script&lang=js"
import style0 from "./NewSidebar.vue?vue&type=style&index=0&id=fa9c5084&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports